// extracted by mini-css-extract-plugin
export default {"parent":"no-mobile-support__parent___M_1v8","emoji":"no-mobile-support__emoji___wQy5o","child":"no-mobile-support__child___VFL16"};